import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services/menu.service';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Ente } from '@app/_models/ente';
import { Categoria } from '@app/_models/categoria';
import { Idioma } from '@app/_models/idioma';
import { Noticia, NoticiaTraduccion } from '@app/_models/noticia';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { AlertService, DepartamentosService } from '@app/_services';
import { EventosService } from '@app/_services/eventos.service';
import { Evento } from '@app/_models/evento';

@Component({
  selector: 'app-eventos',
  templateUrl: './eventos.component.html',
})
export class EventosComponent implements OnInit {
  listaEntesAdministrados: Ente[] = [];
  selectedOrg: Ente;
  listaPublicaciones: Evento[] = [];
  public seleccionados: number[] = [];

  lang;
  private translate: TranslateService;
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;

  constructor(
    private eventosService: EventosService,
    private idiomaService: IdiomasService,
    private organizacionService: OrganizacionesService,
    private menuService: MenuService,
    public router: Router,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService,
    private modalService: NgbModal,
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('eventos.cabecera');
    this.eventosService.getEntesAdministrados().subscribe((result) => {
      this.listaEntesAdministrados = result.data;
      if(this.listaEntesAdministrados.length>0){
        this.selectedOrg=this.listaEntesAdministrados[0];
        this.eventosService
        .getPublicacionesFromEnte(this.selectedOrg.id)
        .subscribe((result) => {
          console.log(result);
          this.listaPublicaciones = result.data;
          console.log(
            'Eventos cargados: ' + this.listaPublicaciones.length
          );
        });
      }
    });
  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
  }

  loadPublicaciones(value, dropDownControl: DropDownListComponent) {
    //dropDownControl.writeValue("old value");
    console.log('Cargando eventos de :' + value.id);
    this.eventosService
      .getPublicacionesFromEnte(this.selectedOrg.id)
      .subscribe((result) => {
        console.log(result);
        this.listaPublicaciones = result.data;
        console.log(
          'Publicaciones cargadas: ' + this.listaPublicaciones.length
        );
      });
  }

  onClickNuevo() {
    if (this.selectedOrg == null) {
      this.alertService.warn(
        this.translateService.instant('publicaciones.selectente')
        );
    } else {
      this.router.navigate(['eventos-crear',{ idorg:this.selectedOrg.id }]);
    }
  }

  onClickEliminar(content){
    console.log('Eliminando...');
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  onClickEditar(){
    this.router.navigate(['eventos-editar',{idorg:this.selectedOrg.id, idevento:this.seleccionados[0] }]);
  }

  onClickPortada(){
    console.log('Actualizando portada...');

    if (this.seleccionados.length > 0) {
      this.eventosService
      .actualizarPortada(this.seleccionados[0])
      .subscribe((result) => {
        if (!result.error) {
          this.alertService.success(
            this.translateService.instant('videos.success')
          );
        } else {
          this.alertService.error(
            this.translateService.instant('videos.error')
          );
          return;
        }
      });
    } else{
      this.alertService.info(
        this.translateService.instant('publicaciones.selectevento')
      );
    }
  }

  cellClick(){
    this.router.navigate(['eventos-editar',{idorg:this.selectedOrg.id, idevento:this.seleccionados[0] }]);
  }

  eliminarRegistro(contentloading){
    console.log('Eliminar registro');
    this.eventosService.delete({ codigos: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.eventosService.getPublicacionesFromEnte(this.selectedOrg.id).subscribe((result) => {
            this.listaPublicaciones = result.data;
          }
          );
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }

  onClickCategorias(){
    this.router.navigate(['eventos-categorias',{idorg:this.selectedOrg.id }]);
  }

  selectedKeysChange(rows: number[]) {
    this.seleccionados = rows;
    console.log("Seleccionado ID: " + this.seleccionados[0])
  }

  onClickInscripciones(){
    if(this.seleccionados.length!=1){
      this.alertService.info(this.translate.instant('eventos.seleccionauno'));
    }
    else{
      this.router.navigate(['evento-inscripciones',{idevento:this.seleccionados[0] }]);
    }
  }
  onClickInscripcionesCell(evento){
      this.router.navigate(['evento-inscripciones',{idevento:evento.id }]);
    
  }
}
